import styled from '@emotion/styled';
import { PureComponent } from 'react';

import employeeBackgroundImage from '../../../assets/employee.png';
import employee2BackgroundImage from '../../../assets/employee2.png';
import employee3BackgroundImage from '../../../assets/employee3.png';
import employeeEduBackgroundImage from '../../../assets/employeeEdu.png';
import hackerBackgroundImage from '../../../assets/hacker.png';
import hacker2BackgroundImage from '../../../assets/hacker2.png';
import hacker3BackgroundImage from '../../../assets/hacker3.png';
import hackerEduBackgroundImage from '../../../assets/hackerEdu.png';

type hackerEmployeeImg = {
  image: string;
  layout: string;
};

const hackerImages = [
  { image: hackerBackgroundImage, layout: 'DEFAULT' },
  { image: hacker2BackgroundImage, layout: 'DEFAULT' },
  { image: hacker3BackgroundImage, layout: 'DEFAULT' },
  { image: hackerEduBackgroundImage, layout: 'EDU' },
];
const employeeImages = [
  { image: employeeBackgroundImage, layout: 'DEFAULT' },
  { image: employee2BackgroundImage, layout: 'DEFAULT' },
  { image: employee3BackgroundImage, layout: 'DEFAULT' },
  { image: employeeEduBackgroundImage, layout: 'EDU' },
];

function getRandomImage(images: hackerEmployeeImg[], isEduLayout?: boolean) {
  const layoutType = isEduLayout ? 'EDU' : 'DEFAULT';
  const imgs = images.filter((i) => i.layout === layoutType);

  const random = Math.floor(Math.random() * imgs.length);
  return imgs[random].image;
}

class LobbyBackgroundImages extends PureComponent<{
  isEduLayout?: boolean;
  showOuterGlow?: boolean;
}> {
  render() {
    const { isEduLayout, showOuterGlow } = this.props;

    return (
      <>
        <LeftBackgroundImage
          css={{
            backgroundImage: `url(${getRandomImage(
              hackerImages,
              isEduLayout,
            )})`,
            filter: showOuterGlow
              ? `drop-shadow(0 0 60px rgba(250, 50, 50, .4))`
              : undefined,
            opacity: showOuterGlow ? undefined : 0.2,
            zIndex: showOuterGlow ? -1 : undefined,
          }}
        />
        <RightBackgroundImage
          css={{
            backgroundImage: `url(${getRandomImage(
              employeeImages,
              isEduLayout,
            )})`,
            filter: showOuterGlow
              ? `drop-shadow(0 0 60px rgba(0, 186, 255, .4))`
              : undefined,
            opacity: showOuterGlow ? undefined : 0.2,
            zIndex: showOuterGlow ? -1 : undefined,
          }}
        />
      </>
    );
  }
}

export default LobbyBackgroundImages;

const BackgroundImage = styled('div')`
  position: fixed;
  pointer-events: none;
  width: 50%;
  height: 45vw;
  bottom: 0;
  background-size: auto 90%;
  background-repeat: no-repeat;

  @media screen and (max-width: 1000px) {
    background-image: none;
  }
`;

export const LeftBackgroundImage = styled(BackgroundImage)({
  backgroundPosition: 'bottom left',
  left: 0,
});

export const RightBackgroundImage = styled(BackgroundImage)({
  backgroundPosition: 'bottom right',
  right: 0,
});
